var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.4 77.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.7,68.2c2.1,2,2.2,5.4.1,7.6-1,1.1-2.4,1.6-3.8,1.6s-2.7-.5-3.7-1.5L1.6,42.6c-1-1-1.6-2.4-1.6-3.8s.6-2.8,1.6-3.8L36.3,1.5c2.1-2,5.5-2,7.5.1,2,2.1,2,5.5-.1,7.5l-30.7,29.5,30.7,29.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.58fe5d36d7bfca2de967a491503f34bd.svg";
export { ForwardRef as ReactComponent };